import { ApiWeeklySchedule, SsmoMenuSource } from 'apis/merchant-onboarding-service/types';

import { SsmoTask, SsmoTaskStatus, SsmoStepsIdentifiers, SsmoStepStatus } from './constants';

export type SelfServeStepType = (typeof SsmoStepsIdentifiers)[keyof typeof SsmoStepsIdentifiers];

export type TaskType = (typeof SsmoTask)[keyof typeof SsmoTask];

export type ContractInfoWizardStepType = (typeof SsmoStepsIdentifiers)[keyof typeof SsmoStepsIdentifiers];

type SelfServeWizardComponentProps = {
  goToNextStep: () => void;
  goToPrevStep: () => void;
  setUpdateIsInProgress: (inProgress: boolean) => void;
  setNextButtonDisabled: (disabled: boolean) => void;
};

export type ContractInfoWizardStep = {
  title: string;
  subtitle?: string;
  identifier: SelfServeStepType;
  component: React.ComponentType<SelfServeWizardComponentProps>;
  percentageFilled: number;
};

export type SsmoTaskStep = {
  stepId: SsmoStepsIdentifiers;
  status: SsmoStepStatus;
};

export type TasksData = Record<SsmoTask, { status: SsmoTaskStatus; steps: SsmoTaskStep[] }>;

type LocalizedValue = {
  lang: string;
  value: string;
};

type CityConfig = {
  id: string;
  slug: string;
  name: LocalizedValue[];
};

export type CountryConfig = {
  code: string;
  name: string;
  cities: CityConfig[];
};

export type TrialCommission = {
  commissionValue: string;
  commissionDuration: number;
};

export type CommissionsConfig = {
  deliveryCommission?: string;
  takeawayCommission?: string;
  subscriptionCommission?: string;
  selfDeliveryCommission?: string;
  selfDeliverySubscriptionCommission?: string;
  trialCommission?: TrialCommission;
};

export type TabletType = 'IPAD' | 'ANDROID';

export type TabletConfiguration = {
  tabletType: TabletType;
  tabletCost: string;
};

export type DevicesConfig = {
  tabletConfiguration: TabletConfiguration;
  mobileDataOption?: {
    cost: string;
    mandatory: boolean;
  };
  printerOptionConfiguration?: {
    cost: string;
  };
};

export const menuPhotoShootOptions = ['MERCHANT_OWN_PHOTO', 'WOLT_PHOTOSHOOT', 'WOLT_STOCK_PHOTOS'] as const;

export type MenuPhotoShootOption = (typeof menuPhotoShootOptions)[number];

export type SsmoCountryConfig = {
  commissionsConfig: CommissionsConfig;
  devicesConfig: DevicesConfig;
  menuPhotoShootPricingConfig: { prices: { [key in MenuPhotoShootOption]: string | null } };
};

export type InboundMerchantVenue = {
  name: string;
  address: string;
  postCode: string;
  city: string;
  isWoltCity: boolean;
  openingTimes?: ApiWeeklySchedule;
};

export type SsmoMenuFile = {
  name: string;
  sizeInBytes: number;
};

export type InboundMerchant = {
  businessId: string;
  country: Country;
  createdAt: number;
  email: string;
  firstName: string;
  joinedToWoltPlus: boolean;
  language: string;
  lastName: string;
  menuPhotoShootChoice: null;
  merchantId: string;
  name: string;
  needsMobileDataPackage: boolean;
  needsPrinter: boolean;
  partnershipManagerId: string;
  phoneNumber: string;
  ssmoMenuFiles: SsmoMenuFile[];
  ssmoMenuFileLink: string | null;
  ssmoMenuSource: SsmoMenuSource | null;
  venues: InboundMerchantVenue[];
  website: null;
  businessName: string;
  address: string;
  postCode: string;
  city: string;
};
